<div class="row w-100 text-left">
    <form autocomplete="off" [formGroup]="form" (ngSubmit)="search()">
        <div class="card-inline margin-left-medium margin-right-medium">
            <mat-form-field>
                <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha desde">
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error *ngIf="f.from.errors && f.from.errors.required">
                    Ingrese la fecha desde
                </mat-error>
            </mat-form-field>
        </div>
        <div class="card-inline margin-right-medium">
            <mat-form-field>
                <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha hasta">
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error *ngIf="f.to.errors && f.to.errors.required">
                    Ingrese la fecha hasta
                </mat-error>
            </mat-form-field>
        </div>
        <div class="card-inline margin-right-medium">
            <button mat-flat-button color="primary">Buscar</button>
        </div>
        <div class="card-inline">
            <b> {{ total }} </b>
        </div>
    </form>
</div>
<div class="card-content margin-botton-medium">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
        <table class="search-table" mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="Aliquot">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Alícuota
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Aliquot }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Amount">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Monto
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.Amount }}</div>
                </td>
            </ng-container>

            <ng-container matColumnDef="PercentageText">
                <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                    Porcentaje
                </th>
                <td class="search-table-cell" mat-cell *matCellDef="let element">
                    <div>{{ element.PercentageText }}</div>
                </td>
            </ng-container>

            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </p-scrollPanel>
    <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
</div>